<div class="request-second-step">
    <ng-container *ngIf="!!selectedRequest?.selectedMotive?.action || selectedRequest?.selectedMotive?.faqs">
        <create-request-faq-selfcare [motive]="selectedRequest?.selectedMotive"></create-request-faq-selfcare>
    </ng-container>

    <div class="third-step-container"
        [ngStyle]="{'height': selectedRequest?.selectedMotive?.selfcare === selfcareEnum.EDPONLINE ||
            selectedRequest?.selectedMotive?.selfcare === selfcareEnum.EDPPT || selectedRequest?.selectedMotive?.faqs
            ? '100%' : 'calc(100vh - 182px)'
        }"
        *ngIf="!selectedRequest?.selectedMotive?.selfcare || (selectedRequest?.selectedMotive?.selfcare === selfcareEnum.OUTROS && !selectedRequest?.selectedMotive?.faqs)"
    >
        <create-request-form
            (submitForm)="submit($event)"
            (goBack)="goBack()"
            [request]="selectedRequest"
            [selectedContract]="selectedContract"
        ></create-request-form>
    </div>

    <div class="third-step-container others-section"
        [ngClass]="{'others-section-bottom': !showForm && !!isMobile}"
        *ngIf="selectedRequest?.selectedMotive?.selfcare === selfcareEnum.OUTROS && !!selectedRequest?.selectedMotive?.faqs"
    >
        <div class="d-flex flex-column help-section">
            <div class="d-flex flex-row cursor-pointer mb-4 mb-md-0" (click)="showForm = !showForm">
                <span class="title">{{"pt.edp.edponline.requests.operations.help" | translate}}</span>
                <i class="icon-edponline-Bop-073" [ngClass]="{'rotate-180': !!showForm}"></i>
            </div>
            <div class="card form-card" *ngIf="!!showForm">
                <span class="description">{{"pt.edp.edponline.requests.operations.help.descripion" | translate}}</span>
                <create-request-form
                    (submitForm)="submit($event)"
                    (goBack)="goBack()"
                    [request]="selectedRequest"
                    [selectedContract]="selectedContract"
                    [btnText]="'pt.edp.edponline.requests.operations.help.submit'"
                ></create-request-form>
            </div>

        </div>

    </div>
</div>
